import animationStyles from '@/components/Atoms/Animation/Animation.module.css';
import { Button } from '@/components/Atoms/Button/Button';
import classNames from 'classnames';
import type { ComponentProps, FC } from 'react';
import styles from './CardLinks.module.css';

export const CardLinks: FC<{ links: ComponentProps<typeof Button>[] }> = ({ links }) => (
    <ul className={classNames(animationStyles.fadeChildren, styles.list)} data-cds-sizing="compact">
        {links.map((link, index) => (
            <li key={index}>
                <Button kind="tertiary" {...link} />
            </li>
        ))}
    </ul>
);
